'use strict';

import Dispatcher from './../Dispatcher';
import Constants from './../Constants';

const ActionTypes = Constants.ActionTypes.Actor;

const ActorActionCreator = {
	loadActorChatRatings: function (actorId) {
		Dispatcher.dispatch({
			type: ActionTypes.LOAD_CHAT_RATINGS,
			actorId,
		});
	},

	loadActorInterviews: function (
		actorId,
		imageSize = Constants.Interviews.IMAGE_SIZE_720,
		placeholder = true,
		durationFormat = Constants.Interviews.DURATION_SEC,
	) {
		Dispatcher.dispatch({
			type: ActionTypes.LOAD_INTERVIEWS,
			actorId,
			imageSize,
			placeholder,
			durationFormat,
		});
	},

	loadModelRecommendations: function (actorId, first = 4, isExtended = false, ageRating = 16) {
		Dispatcher.dispatch({
			type: ActionTypes.LOAD_RECOMMENDED_MODELS,
			actorId,
			first,
			isExtended,
			ageRating,
		});
	},
};

export default ActorActionCreator;
